import { getDateRange } from "../../calendar/helpers/filter/dateRange";
import { getSetting, setSetting } from "../../common/helpers/settingStorageHelpers";
import { FILTER_TYPE } from "../constants";

const SETTING_KEYS = {
    Settings: "calendarSettings",
};
export const persistSettings = (newSettings) => {
    if (!newSettings) return;

    let settings = getSetting(SETTING_KEYS.Settings);

    newSettings = { ...settings, ...newSettings };

    if (newSettings.filter) {
        if (!newSettings.filter.time) {
            newSettings.filter.time = INITIAL_SETTING.filter.time;
            newSettings.filter.dateRange = getDateRange(
                { time: newSettings.filter.time },
                newSettings.timezoneOffset
            );
        }
        newSettings.filter.type = FILTER_TYPE.custom;
    }

    setSetting(SETTING_KEYS.Settings, newSettings);
};

export const getSettingsWithNoFilter = () => {
    let settings = getSetting(SETTING_KEYS.Settings);

    if (settings && settings.filter) {
        delete settings.filter;
    }

    return settings;
};
